import * as React from "react";

function SvgCloseIcon(props) {
  return <svg viewBox="0 0 28.3 28.3" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M52.4-166.2c3.2 0 3.2-5 0-5s-3.2 5 0 5zM16.8 13.9L26.9 3.8c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0L14.7 11.8 4.6 1.7c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l10.1 10.1L2.5 24c-.6.6-.6 1.5 0 2.1.3.3.7.4 1.1.4s.8-.1 1.1-.4l10-10.1 10.1 10.1c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1L16.8 13.9z" /></svg>;
}

export default SvgCloseIcon;